function getMessageTimestamp(message) {
  const value =
    message?.dateCreated ||
    message?.createdAt ||
    message?.timestamp ||
    null;
  if (!value) return null;
  const timestamp = new Date(value).getTime();
  return Number.isFinite(timestamp) ? timestamp : null;
}

export function getUnreadCountForUser(conversation, userId) {
  if (!conversation || !userId) return 0;
  const unreadBy = conversation?.unreadBy;
  const raw =
    unreadBy && typeof unreadBy === "object"
      ? unreadBy[String(userId)] ?? unreadBy[userId]
      : 0;
  const count = Number(raw || 0);
  return Number.isFinite(count) ? count : 0;
}

export function getReadStateForUser(conversation, userId) {
  if (!conversation || !userId) return null;
  const readStateByUser = conversation?.readStateByUser;
  if (!readStateByUser || typeof readStateByUser !== "object") return null;
  return readStateByUser[String(userId)] ?? readStateByUser[userId] ?? null;
}

export function getLatestOutboundReceiptState({
  conversation,
  messages,
  currentUserId,
}) {
  const list = Array.isArray(messages) ? messages : [];
  if (!conversation || !currentUserId || !list.length) {
    return {
      latestOutboundMessageId: null,
      readReceiptLabel: undefined,
    };
  }

  const latestMessage = list[list.length - 1] || null;
  const outboundMessages = list.filter(
    (message) => String(message?.author?._id) === String(currentUserId),
  );
  const latestOutboundMessage = outboundMessages.length
    ? outboundMessages[outboundMessages.length - 1]
    : null;

  if (!latestMessage || !latestOutboundMessage) {
    return {
      latestOutboundMessageId: null,
      readReceiptLabel: undefined,
    };
  }

  const latestOutboundMessageId = latestOutboundMessage?._id || null;
  if (
    !latestOutboundMessageId ||
    String(latestMessage?._id) !== String(latestOutboundMessageId)
  ) {
    return {
      latestOutboundMessageId,
      readReceiptLabel: undefined,
    };
  }

  const participants = Array.isArray(conversation?.participants)
    ? conversation.participants
    : [];
  const otherParticipantIds = participants
    .map((participant) => String(participant?._id || participant))
    .filter((id) => id && id !== String(currentUserId));

  if (!otherParticipantIds.length) {
    return {
      latestOutboundMessageId,
      readReceiptLabel: undefined,
    };
  }

  const latestOutboundTimestamp = getMessageTimestamp(latestOutboundMessage);
  const seenByEveryone = otherParticipantIds.every((participantId) => {
    const readState = getReadStateForUser(conversation, participantId);
    if (!readState) return false;

    if (
      readState?.lastReadMessageId &&
      String(readState.lastReadMessageId) === String(latestOutboundMessageId)
    ) {
      return true;
    }

    const lastReadAt = getMessageTimestamp({
      timestamp: readState?.lastReadAt,
    });
    return (
      latestOutboundTimestamp !== null &&
      lastReadAt !== null &&
      lastReadAt >= latestOutboundTimestamp
    );
  });

  return {
    latestOutboundMessageId,
    readReceiptLabel: seenByEveryone ? "Seen" : undefined,
  };
}
